import KioskSummary from './KioskSummary'
export default KioskSummary
